import React from 'react';
var Highcharts = require('highcharts');

export default class EnvironmentPlay extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    componentDidMount() {
        this.renderChart();
    }

    componentDidUpdate() {
        this.renderChart();
    }

    renderChart() {
        let fontSize = this.props.campaignType === 'posting' ? '12px' : '9px';
        Highcharts.chart("environment_container",
            {
                chart: {
                    type: "area"
                },
                title: {
                    text: null
                },
                credits: false,

                xAxis: {
                    tickLength: 5,
                    tickWidth: 0.3,
                    lineWidth: 0.3,
                    categories: this.props.environment.map((x) => { return x.name; }),
                    labels: {
                        style: { whiteSpace: 'nowrap', fontSize: fontSize },
                        autoRotation: false
                    }
                },
                yAxis: {
                    title: {
                        text: this.props.dataType,
                        style: { fontSize: '12px' },
                    },
                    labels: {
                        formatter: function () {
                            return this.value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                        },
                        style: { fontSize: fontSize }
                    },
                    min: Math.min.apply(Math,
                        this.props.environment.map((x) => {
                                return x.value;
                            })) *
                        0.75
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        enableMouseTracking: true,
                        dataLabels: {
                            enabled: true,
                            overflow: "allow",
                            crop: false,
                            style: {
                                fontWeight: "normal",
                                fontSize: fontSize
                            },
                            formatter: function () {
                                return this.y
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                            }
                        }
                    },
                    area: {
                        fillOpacity: 1,
                        marker: {
                            enabled: false
                        }
                    }
                },
                legend: {
                    layout: 'horizontal',
                    align: 'right',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0,
                    floating: true,
                    enabled: this.props.showTarget
                },

                tooltip: {
                    formatter: function () {
                        const header = `${this.key}<br/>`;
                        const body = `<span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${this.y
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}</b>`;
                        return header + body;
                    },
                    style: {
                        fontSize: '12px'
                    }
                },
                series: [
                    {
                        name: "Delivered",
                        color: this.props.color,
                        type: "column",
                        data: this.props.environment.map((x) => { return x.value; })
                    }
                ]
            });
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>Environment</h4>
                </div>
                <div className="col-md-12">
                    <div id="environment_container"></div>
                </div>
            </div>
        );
    }
}